var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGalleryView = function SvgGalleryView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gallery-view_svg__a)",
    fill: "#F1892B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.243.24h-3.335v3.334h3.335V.239ZM19.243 4.948h-3.335v3.334h3.335V4.948ZM19.243 9.66h-3.335v3.335h3.335V9.661ZM19.243 14.37h-3.335v3.334h3.335v-3.335ZM14.08.24h-3.334v3.334h3.335V.239ZM14.08 4.948h-3.334v3.334h3.335V4.948ZM14.08 9.66h-3.334v3.335h3.335V9.661ZM14.08 14.37h-3.334v3.334h3.335v-3.335ZM8.912.24H5.579v3.334h3.334V.239ZM8.912 4.948H5.579v3.334h3.334V4.948ZM8.912 9.66H5.579v3.335h3.334V9.661ZM8.912 14.37H5.579v3.334h3.334v-3.335ZM3.748.24H.414v3.334h3.334V.239ZM3.748 4.948H.414v3.334h3.334V4.948ZM3.748 9.66H.414v3.335h3.334V9.661ZM3.748 14.37H.414v3.334h3.334v-3.335Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gallery-view_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.414 .24)",
    d: "M0 0h18.829v17.464H0z"
  })))));
};
export default SvgGalleryView;